import { render, staticRenderFns } from "./Franchisee.vue?vue&type=template&id=e9aeb8b6"
import script from "./Franchisee.vue?vue&type=script&lang=js"
export * from "./Franchisee.vue?vue&type=script&lang=js"
import style0 from "./Franchisee.vue?vue&type=style&index=0&id=e9aeb8b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports